var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Zisk")]),_vm._v(" "),_c('LineChart',{attrs:{"url":"/api/reports/profit","label":"Zisk"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }